import { render, staticRenderFns } from "./typeInfo.vue?vue&type=template&id=1ca60cee"
import script from "./typeInfo.vue?vue&type=script&lang=js"
export * from "./typeInfo.vue?vue&type=script&lang=js"
import style0 from "./typeInfo.vue?vue&type=style&index=0&id=1ca60cee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports